import { ref, readonly } from 'vue'

const cartCount = ref(0)
let openCartHandler = null

export function useIngresoCart() {
  const setCartCount = (count) => {
    cartCount.value = Math.max(0, Number(count) || 0)
  }

  const registerOpenCart = (handler) => {
    openCartHandler = typeof handler === 'function' ? handler : null
  }

  const openCart = () => {
    openCartHandler?.()
  }

  const clearCartRegistration = () => {
    openCartHandler = null
  }

  return {
    cartCount: readonly(cartCount),
    setCartCount,
    registerOpenCart,
    openCart,
    clearCartRegistration,
  }
}
